import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BlanksRegionComponent } from './blanks-region.component';

@NgModule({
  imports: [
    RouterModule
  ],
  declarations: [
    BlanksRegionComponent
  ],
  providers: [],
  exports: [
    BlanksRegionComponent
  ]
})
export class BlanksRegionModule {}
